import React, { useEffect, useState } from "react";
import Head from "../../../../layout/head/Head";
import Content from "../../../../layout/content/Content";
import TablePageHeading from "../page_heading/TablePageHeading";
import { Alert, Spinner } from "reactstrap";
import { Button, Col, Row } from "../../../../components/Component";
import { BiCog, BiLinkExternal } from "react-icons/bi";
import { Link } from "react-router-dom";

const type = "SMART_INVOICE_CONFIG";

const SmartInvoiceConfig = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = window.setTimeout(() => setLoading(false), 700);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <>
      <Head title="Smart Invoice Config" />
      <Content>
        <TablePageHeading title="Smart Invoice Config" page_type={type} pageData={[]} />

        {loading ? (
          <div className="card card-bordered shadow-sm">
            <div className="card-inner py-5">
              <div className="d-flex flex-column align-items-center justify-content-center text-center">
                <Spinner />
                <div className="fs-15px mt-3 text-soft">Preparing Smart Invoice configuration panel...</div>
              </div>
            </div>
          </div>
        ) : (
          <Row className="g-gs">
            <Col xs="12">
              <div className="card card-bordered shadow-sm">
                <div className="card-inner d-flex flex-wrap justify-content-between align-items-start gap-3">
                  <div>
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <span
                        className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10 text-primary"
                        style={{ width: 42, height: 42 }}
                      >
                        <BiCog className="fs-4" />
                      </span>
                      <span className="text-uppercase small fw-bold text-primary">Optional Module</span>
                    </div>
                    <div className="fs-20px fw-bold">Smart Invoice Configuration</div>
                    <div className="text-soft mt-2">
                      This page is reserved for provider credentials, account mapping, and future external connection settings.
                    </div>
                  </div>

                  <Link to="/dashboard/smart_invoices">
                    <Button color="light" className="d-flex align-items-center justify-content-center">
                      <BiLinkExternal className="me-1" />
                      Back To Invoices
                    </Button>
                  </Link>
                </div>
              </div>
            </Col>

            <Col xs="12">
              <Alert color="info" className="mb-0">
                Config was mentioned as optional. The placeholder route is ready, but no provider settings have been wired yet.
              </Alert>
            </Col>
          </Row>
        )}
      </Content>
    </>
  );
};

export default SmartInvoiceConfig;
